

export const BASE_URL = "https://api.indiahirings.com"
export const ADMIN_AUTH = "Bearer 1|qzdKsGqCl4x2vKH2c2b4Qt1Exn6KcIf5QkswXJoH90ca7775"

export const EMPLOYER_COMPANY_LOGO_SAVE_URL = "https://api.indiahirings.com/uploads/company/"
export const RESUME_VIEW = "https://api.indiahirings.com/uploads/candidate/resume/"
export const CANDIDATE_PROFILE = "https://api.indiahirings.com/uploads/candidate/profile/";
export const GMAIL_REGISTER = "https://api.indiahirings.com/api/auth/login-google"
// Payment Gateway
export const PAYMENT_GATEWAY = "https://api.indiahirings.com/employer/employer-subscriptions-payment";
export const PAYMENT_GATEWAY_TOP_UP = "https://api.indiahirings.com/employer/employer-subscriptions-topup-payment";
export const RAZOR_PAY_KEY = "rzp_test_bcjMYLCrJyB435";

export const JOB_HIRING_TAG = "job-hiring-tag"
// Admin URLs
export const ADMIN = "admin"
export const ADMIN_PRODUCT_REVIEW = "product-reviews"
export const ADMIN_REVIEWS = "company-reviews"
export const Unlock_Candidate = "https://api.indiahirings.com/employer/candidate-unlock-profile"
export const Unlock_Candidate_From_Job_Apply = "https://api.indiahirings.com/employer/candidate-unlock-from-job-apply"
export const Unlocked_Candidate_LIST = "https://api.indiahirings.com/employer/candidate-unlock-list"
export const Candidate_Show = "https://api.indiahirings.com/employer/candidate-show-profile"
export const JOBS = "jobs"

export const EMPLOYER = "employer"
export const EMPLOYER_SUBSCRIPTIONS = "employer-subscriptions"
export const EMPLOYER_SUBSCRIPTIONS_TOPUP = "employer-subscriptions-topup"

export const EMPLOYER_SUBSCRIPTIONS_HISTORY = "employer-subscriptions-history"
export const EMPLOYER_SUBSCRIPTIONS_PAYMENT = "employer-subscriptions-payment"
export const EMPLOYER_SUBSCRIPTIONS_PAYMENT_TOPUP = "employer-subscriptions-topup-payment"
export const EMPLOYER_SUBSCRIPTIONS_ACTIVE = "employer-active-subscriptions"
export const APPLICANTS = "applicants"
export const EMPLOYER_COMPANY_LOGO = "employer-company-logo"
export const EMPLOYER_COMPANY_PROFILE = "employer-company-profile"
export const EMPLOYER_APPLIED_CANDIDATES = "candidate-job-apply"
export const EMPLOYER_SEARCHED_CANDIDATES = "search-candidate"
export const EMPLOYER_APPLICANT_INTERVIEW_SCHEDULED = "applicant-interview-schedule"
export const EMPLOYER_SAVED_CANDIDATE = "employer-candidate-saved"
export const EMPLOYER_CANDIDATE_JOB_APPLY_EXPORT_BY_JOBUUID = "candidate-job-apply-download"
export const EMPLOYER_CANDIDATE_UNLOCK_LIST_EXPORT = "candidate-unlock-list-download"

export const CORE_LOCATIONS = "fetch-core-location"
export const CANDIDATE_CORE_LOCATIONS = "fetch-core-locations"
export const CORE_EDUCATIONS = "fetch-core-educations"
export const CORE_SKILLS = "fetch-core-skills"
export const CORE = "core"
export const CORE_CITY = "core-job-city"
export const CORE_JOB_COMPANY = "core-job-company"
export const CORE_JOB_DEPARTMENTS = "core-job-departments"
export const CORE_JOB_SKILLS = "core-job-skills"
export const CORE_JOB_TITLES = "core-job-title"
export const CORE_JOB_EDUCATIONS = "core-job-educations"
export const CORE_JOB_EDUCATION_COURSE = "core-job-education-course"
export const CORE_JOB_EDUCATION_COURSE_SPECIALTY = "core-job-course-specialty"

export const CANDIDATE = "candidate"
export const PUBLIC_TITLES = "fetch-core-titles"
export const CANDIDATE_RECOMMENDED_JOBS = "fetch-recommended-jobs"
export const CANDIDATE_SEARCH_HISTORY = "candidate-search-history"
export const CANDIDATE_CAREER_PROFILE = "fetch-candidate-career-profile"
export const CANDIDATE_JOB_APPLY = "candidate-job-apply"
export const CANDIDATE_JOB_SAVED = "candidate-job-saved"
export const CANDIDATE_JOB_SEARCH = "fetch-jobs-list"
export const CANDIDATE_KEYWORD_SUGGESTION = "get-title-skill-company-list"

export const CANDIDATE_DETAILS_BY_PARAM = "fetch-candidate"
export const CANDIDATE_BASIC_DETAILS_PARAM = "basic_details=1"
export const CANDIDATE_CERTIFICATION_PARAM = "certifications=1"
export const CANDIDATE_EDUCATION_PARAM = "education=1"
export const CANDIDATE_EMPLOYMENT_PARAM = "employment=1"
export const CANDIDATE_ITSKILLS_PARAM = "it_skills=1"
export const CANDIDATE_JOB_PREFERENCE_PARAM = "job_preference=1"
export const CANDIDATE_LANGUAGES_PARAM = "candidate_languages=1"
export const CANDIDATE_PROJECTS_PARAM = "projects=1"
export const CANDIDATE_CURRENT_COMPANY_PARAM = "current_company=1"

export const CANDIDATE_BASIC_DETAILS = "candidate-basic-details"
export const CANDIDATE_PROFILE_PHOTO = "candidate-basic-details-profile"
export const CANDIDATE_RESUME = "candidate-basic-details-resume"
export const CANDIDATE_CERTIFICATIONS = "candidate-certifications"
export const CANDIDATE_EDUCATIONS = "candidate-educations"
export const CANDIDATE_EMPLOYMENT = "candidate-employment"
export const CANDIDATE_SKILLS = "candidate-it-skills"
export const CANDIDATE_JOB_PREFERENCE = "candidate-job-preference"
export const CANDIDATE_LANGUAGES = "candidate-languages"
export const CANDIDATE_PROJECTS = "candidate-projects"
export const COMPANY_REVIEW_SAVE = "company-review-save"

export const Media_View = "https://api.indiahirings.com/uploads/company/media/"

export const EMPLOYER_COMPANY_MEDIA_URL = "https://api.indiahirings.com/uploads/company/media/"
export const PUBLIC = "api"
export const COUNTRIES = "global-address-countries"
export const STATES = "global-address-states"
export const CITIES = "global-address-cities"
export const MOST_SEARCH_JOBS_DEPARTMENTS = "most-search-jobs-department"
export const PUBLIC_SUBSCRIPTION_EMPLOYER = "fetch-subscription-list/employer"
export const PUBLIC_CONTACT_US = "sales-contact-us"
export const PROFILE_VERIFICATION_EMAIL = "profile-verification/email"
export const PROFILE_VERIFICATION_PHONE = "profile-verification/phone"
export const PROFILE = "profile"


export const POPULAR_JOB_ROLES = "popular-job-roles"
export const JOBS_BY_DEPARTMENTS = "jobs-by-category"
export const JOBS_BY_ROLES = "jobs-by-roles"
export const LATEST_JOBS = "most-active-recent-jobs"
export const TOP_COMPANIES = "most-active-jobs-company"
export const PUBLIC_JOBS = "jobs"

export const COMPANY_LIST = "fetch-company-list"
export const COMPANY_DETAILS = "fetch-company-details"
export const COMPANY_JOB_LIST = "fetch-company-job-list"
export const COMPANY_REVIEWS = "company-reviews"
export const COMPANY_REVIEW_LIST = "fetch-company-review-list"
export const PRODUCT_REVIEW_LIST = "product-reviews-list"
